import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";

export default function CatalogPagination({ page, pages, onChange }) {
  const { t } = useLanguage();
  if (pages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2 mt-12" data-testid="pagination">
      <Button
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="border-white/10 text-white/60 font-body text-sm rounded-sm disabled:opacity-30"
      >
        {t.previous}
      </Button>
      <span className="font-body text-sm text-white/40 px-4">{page} / {pages}</span>
      <Button
        variant="outline"
        size="sm"
        disabled={page >= pages}
        onClick={() => onChange(page + 1)}
        className="border-white/10 text-white/60 font-body text-sm rounded-sm disabled:opacity-30"
      >
        {t.next}
      </Button>
    </div>
  );
}
